var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimecards(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Timecards",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer-silhouette",
    transform: "translate(0 0.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-2",
    d: "M19.715,1.447h2.312a.407.407,0,0,0,.405-.406V.406A.407.407,0,0,0,22.026,0H19.715a.407.407,0,0,0-.406.406v.636A.407.407,0,0,0,19.715,1.447Z",
    transform: "translate(-13.765)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-2",
    d: "M10.006,5.837A7.063,7.063,0,0,0,4.984,7.93l1.54,1.112a5.179,5.179,0,1,1-.51.524L4.858,8.07a7.075,7.075,0,1,0,5.148-2.233Z",
    transform: "translate(-2.921 -3.863)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-2",
    d: "M15.586,19.578a1.118,1.118,0,0,1-.88-.434l0,0-2.56-3.311a4.248,4.248,0,1,0,.7-.732l3.321,2.4,0,0a1.116,1.116,0,0,1-.575,2.074Z",
    transform: "translate(-8.447 -9.352)",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimecards);
export default __webpack_public_path__ + "static/media/timecards.29f7375e5d88ebd09bf13113f54fbab5.svg";
export { ForwardRef as ReactComponent };